import { render, staticRenderFns } from "./TrackedKeyDetail.vue?vue&type=template&id=36af3593&scoped=true"
import script from "./TrackedKeyDetail.vue?vue&type=script&lang=js"
export * from "./TrackedKeyDetail.vue?vue&type=script&lang=js"
import style0 from "./TrackedKeyDetail.vue?vue&type=style&index=0&id=36af3593&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af3593",
  null
  
)

export default component.exports